import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase';
import { useAuth } from './AuthContext';
import {
  doc,
  onSnapshot,
  setDoc,
  updateDoc,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';

const ScheduleContext = createContext();
export const useSchedule = () => useContext(ScheduleContext);

export function ScheduleProvider({ children }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  // shape: { '2025-06-01': [ { fid, attributes }, … ], … }
  const [schedule, setSchedule] = useState({});

  // listen to /schedules/{userId}
  useEffect(() => {
    if (!user) return setLoading(false);
    const docRef = doc(db, 'schedules', user.uid);
    const unsub = onSnapshot(docRef, snap => {
      setSchedule(snap.exists() ? snap.data() : {});
      setLoading(false);
    });
    return unsub;
  }, [user?.uid]);

  // helper to add or remove an item on a date
  const addItem = async (date, biz) => {
    if (!user) return;
    const docRef = doc(db, 'schedules', user.uid);
    // ensure doc exists
    await setDoc(docRef, {}, { merge: true });
    await updateDoc(docRef, {
      [date]: arrayUnion({
        fid: biz.attributes.FID,
        attributes: biz.attributes
      })
    });
  };

  const removeItem = async (date, biz) => {
    if (!user) return;
    const docRef = doc(db, 'schedules', user.uid);
    await updateDoc(docRef, {
      [date]: arrayRemove({
        fid: biz.attributes.FID,
        attributes: biz.attributes
      })
    });
  };

  return (
    <ScheduleContext.Provider value={{ schedule, loading, addItem, removeItem }}>
      {children}
    </ScheduleContext.Provider>
  );
}
